import Cookies from 'js-cookie';

export const AUTH_COOKIE = 'auth_token';
const LEGACY_COOKIE = 'auth_token_employee'; // на удаление

const isJWT = (t) => typeof t === 'string' && t.split('.').length === 3;

export const getAuthToken = () => {
    const fresh  = Cookies.get(AUTH_COOKIE);          // 'auth_token'
    const legacy = Cookies.get(LEGACY_COOKIE);        // 'auth_token_employee'

    // Кейс твоей текущей поломки: в auth_token лежит hex-AccountToken,
    // а в auth_token_employee — рабочий JWT. Берём JWT и кладём в основной cookie.
    if (legacy && isJWT(legacy) && !isJWT(fresh)) {
        Cookies.set(AUTH_COOKIE, legacy, { expires: 7 });
        Cookies.remove(LEGACY_COOKIE);
        return legacy;
    }

    if (fresh) return fresh;

    if (legacy) {
        Cookies.set(AUTH_COOKIE, legacy, { expires: 7 });
        Cookies.remove(LEGACY_COOKIE);
        return legacy;
    }
    return null;
};

export const setAuthToken = (token) => {
    Cookies.set(AUTH_COOKIE, token, { expires: 7 });
};

export const clearAuthToken = () => {
    Cookies.remove(AUTH_COOKIE);
    Cookies.remove(LEGACY_COOKIE); // на всякий случай
    localStorage.removeItem('active_role');
};